const PlusIcon = () => (
	<svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
	</svg>
);

PlusIcon.displayName = 'PlusIcon';

const CarIcon = () => (
	<svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 002 12v4c0 .6.4 1 1 1h2"
		/>
		<circle cx="7" cy="17" r="2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
		<circle cx="17" cy="17" r="2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} />
	</svg>
);

CarIcon.displayName = 'CarIcon';

const AlertIcon = () => (
	<svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
		/>
	</svg>
);

AlertIcon.displayName = 'AlertIcon';

export { PlusIcon, CarIcon, AlertIcon };
